import { withTopbarProps } from '@jusbrasil/topbar'
import { withUserSession } from '@jusbrasil-web/shared-user-session'
import { getFirstQueryParam } from '@jusbrasil-web/shared-utils-url'
import { GetServerSideProps } from 'next'

import { AuthLayout, EmailChangeSent } from '../../../components'

const CHANGE_EMAIL_URL = '/configuracoes/alterar-email'

export interface EmailChangeSentPageProps {
  email: string
}

export function EmailChangeSentPage({ email }: EmailChangeSentPageProps) {
  return (
    <AuthLayout>
      <EmailChangeSent email={email} />
    </AuthLayout>
  )
}

const getServerSideProps: GetServerSideProps = async (ctx) => {
  ctx.res?.setHeader('Cache-Control', 'no-cache, no-transform')
  ctx.res?.setHeader('X-Robots-Tag', 'noindex')

  const email = getFirstQueryParam(ctx.query.email)
  if (!email) {
    return {
      redirect: { destination: CHANGE_EMAIL_URL, permanent: false },
    }
  }

  return {
    props: {
      ...withTopbarProps(ctx),
      ...withUserSession(ctx),
      email,
    },
  }
}

export const EmailChangeSentPageExports = {
  getServerSideProps,
}
